import { render } from "./UserStoryMapping.vue?vue&type=template&id=06702817&scoped=true"
import script from "./UserStoryMapping.vue?vue&type=script&lang=js"
export * from "./UserStoryMapping.vue?vue&type=script&lang=js"

import "./UserStoryMapping.vue?vue&type=style&index=0&id=06702817&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06702817"]])

export default __exports__